import { AfterViewInit, Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { firstValueFrom } from 'rxjs';
import { PeriodosService } from '../../../services/riesgo-credito/riesgos/periodos.service';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoCredito } from '../../../shared/catalogos';
import { formatear, FuncionesRiesgo, FuncionesMes } from '../../funciones/funcionesGenerales';
import { FiltersM, typesApex } from '../../../components/models';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import { generatePDF } from '../../funciones/makePdf';
import Swal from 'sweetalert2';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);
import moment from 'moment';
import { CatalogosService } from '../../../services/administrador-gestion/catalogos/catalogos.service';
import { PerdidaService } from '../../../services/riesgo-credito/riesgos/perdida.service';
import { perdidaEntity, GraficaPedidaEntity, concentracionEntity, matrizTransicionEntity, cosechaEntity, mayoresDeudoresEntity } from './../entities_riesgos/entities_riesgos';
import { ConcentracionService } from '../../../services/riesgo-credito/riesgos/concentracion.service';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { MatrizTransicionService } from '../../../services/riesgo-credito/riesgos/matriz-transicion.service';
import { zonaEntity, productoEntity, sucursalEntity, sectorEntity } from '../entities_riesgos/entities_riesgos';
import { SucursalService } from '../../../services/riesgo-credito/riesgos/sucursal.service';
import { MatrizFiltroService } from '../../../services/riesgo-credito/riesgos/matriz-filtro.service';
import { CosechasService } from '../../../services/riesgo-credito/riesgos/cosechas.service';
import { mayoresdeudoresService } from '../../../services/riesgo-credito/riesgos/mayoresdeudores.service';
import { promises } from 'node:dns';

@Component({
  selector: 'app-reporte',
  templateUrl: './reporte.component.html',
  styleUrl: './reporte.component.css'
})
export class ReporteComponent implements AfterViewInit{
  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;
  @ViewChild('tendencia', {read: ElementRef}) elementoTendencia: ElementRef | undefined;
  @ViewChild('matriz', {read: ElementRef}) elementoMatriz: ElementRef | undefined;
  @ViewChild('tabla2', {read: ElementRef}) elementoTabla2: ElementRef | undefined;
  @ViewChild('cosechas', {read: ElementRef}) elementoCosechas: ElementRef | undefined;
  @ViewChild('cosechasTabla', {read: ElementRef}) elementoCosechasTabla: ElementRef | undefined;
  @ViewChild('concentracion', {read: ElementRef}) elementoConcentracion: ElementRef | undefined;
  @ViewChild('deudores', {read: ElementRef}) elementoDeudores: ElementRef | undefined;
  @ViewChild('conclusiones', {read: ElementRef}) elementoConclusiones: ElementRef | undefined;
  
  private pdfFile: any;
  private idInstitucion;
  private nombreInstitucion;
  public dateReport;
  private registros = 10000;
  private moneda;

  private bndInteres;
  private submenus;
  private smMoneda;
  private parInclusive;

  public tendenciaA = true;

  public matrizA = true;
  public tabla2 = true;
  public s1 = false;

  public cosechasA = true;
  public s2 = false;
  public tablaCosechas = false;

  public concentracionA = true;
  
  public conclusionesA = true;

  public deudoresA = true;

  download = true;
  reloadElements = false;

  public textEd1Conclusiones = '';


  editable1 = `El análisis gráfico revela un crecimiento de las pérdidas no esperadas, `+
    `superando a partir de abril 2025 a las pérdidas esperadas. `+
    `El crecimiento de las pérdidas no esperadas implica un mayor nivel de incertidumbre.`;

  public DatosAnios;
  public periodo;
  public mes;
  public anio;
  public aniosDisponibles: any [];
  public mesesDisponibles: any [];
  
  public sucursales = [];
  public sucursales2 = [];
  public nombreSucursales = [];
  public nombreSucursales2 = [];

  public Filtros = FiltersM;
  
  constructor(
    readonly dataService: DataService,
    private periodosService: PeriodosService,
    private cookies: CookieService,
    private translate: TranslateService,
    private readonly catalogos: CatalogosService,

    private readonly perdidaService: PerdidaService,
    private readonly concentracionService: ConcentracionService,
    private readonly matrizTransicionService: MatrizTransicionService,
    private matrizTRFiltro: MatrizFiltroService,
    private readonly sucursalService: SucursalService,
    private readonly cosechaService: CosechasService,
    private readonly mayoresdeudoresService: mayoresdeudoresService,
  ){
    this.idInstitucion = Number(cookies.get('idInstitucion'));    
    this.personalizacion();
  }

  onSVG = 'M12 13 4 13 4 11 12 11 12 3 14 3 14 11 22 11V13L14 13 14 21H12L12 13Z'

  ngAfterViewInit(): void {
    if(this.elementoConclusiones){
      this.elementoTendencia.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.onSVG);
      this.elementoMatriz.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.onSVG);
      this.elementoTabla2.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.onSVG);
      this.elementoCosechas.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.onSVG);
      this.elementoCosechasTabla.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.onSVG);
      this.elementoConcentracion.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.onSVG);
      this.elementoDeudores.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.onSVG);
      this.elementoConclusiones.nativeElement.querySelector('.mdc-switch__icon--on').firstChild.setAttribute('d', this.onSVG);
    }
  }

  private async personalizacion(){
    var configInst = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion);
    const inst = await firstValueFrom(
      this.catalogos.getInstitucionesAdmin(configInst.idAdmin)
    );
    this.nombreInstitucion = inst['company_name'];

    this.bndInteres = configInst.interes;
    this.submenus = configInst.tipoMenu;
    this.smMoneda = configInst.moneda;
    this.moneda = configInst.monedaS;
    this.parInclusive = configInst.parInclusive;
    await this.getSucursales();
    this.getPeriodos();
  }
  private async getPeriodos(){
    const info = await firstValueFrom(
      this.periodosService.getByAddUrl_Riesgo('informacionCargada', {InstitucionId: this.idInstitucion})
    );
    this.DatosAnios = formatear.periodosRC(info);
    this.periodo = Number(this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].value);
    this.mes = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].name;
    this.anio = this.DatosAnios.mesesDisponibles[this.DatosAnios.mesesDisponibles.length-1].year;
    this.DatosAnios.aniosDisponibles[this.DatosAnios.aniosDisponibles.length-1].check = true;

    this.aniosDisponibles = this.DatosAnios.aniosDisponibles;
    var aux = [];
    var pos;
    for(var i = 0; i < this.aniosDisponibles.length; i ++){
      if(this.aniosDisponibles[i].check == true){
        pos = i;
      }
    }
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[pos].name){
        aux.push(this.DatosAnios.mesesDisponibles[i]);
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.dateReport = moment(`${this.mes} ${this.anio}`, 'MMM YYYY');
    this.getObjetos();
  }
  getMes(){
    const mes = this.mesesDisponibles.find(m => m.check).value;
    return mes;
  }
  /* funciones para los filtros */
  //AÑOS
  public anioChange(anio: any){
    var pos = 0;
    for(var i =0; i < this.aniosDisponibles.length; i++){
      this.aniosDisponibles[i].check = false;
    }
    for(var i =0; i < this.aniosDisponibles.length; i++){
      if(this.aniosDisponibles[i].value == anio.value){
        this.aniosDisponibles[i].check = true;
        pos = i;
      }
    }
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false
    }
    var aux = [];
    for(var i =0; i < this.DatosAnios.mesesDisponibles.length; i++){
      if(this.DatosAnios.mesesDisponibles[i].year == this.aniosDisponibles[pos].name){
        aux.push(this.DatosAnios.mesesDisponibles[i])
      }
    }
    this.mesesDisponibles=aux;
    this.mesesDisponibles[this.mesesDisponibles.length-1].check = true;
    this.mes = this.mesesDisponibles[this.mesesDisponibles.length-1].name;
    this.anio = this.aniosDisponibles[pos].name;
    this.periodo = Number(this.mesesDisponibles[this.mesesDisponibles.length-1].value);
    this.dateReport = moment(`${this.mes} ${this.anio}`, 'MMM YYYY');
    this.getObjetos();
  }
  public mesChange(mes: any){
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      this.mesesDisponibles[i].check = false;
    }
    var pos =0;
    for(var i = 0; i < this.mesesDisponibles.length; i++ ){
      if(this.mesesDisponibles[i].name == mes.name){
        this.mesesDisponibles[i].check = true;
        pos = i;
      }
    }
    this.mes = this.mesesDisponibles[pos].name;
    this.periodo = Number(this.mesesDisponibles[pos].value);
    this.dateReport = moment(`${this.mes} ${this.anio}`, 'MMM YYYY');
    
    this.getObjetos();
  }
  // objetos
  perdida = new perdidaEntity;
  concentracion = new concentracionEntity;
  concentracion2 = new concentracionEntity;
  matrizTransicion = new matrizTransicionEntity;
  sucursal = new sucursalEntity;
  cosecha = new cosechaEntity;
  mayoresdeudores = new mayoresDeudoresEntity;

  private async getSucursales(){
    this.sucursal.InstitucionId = this.idInstitucion;
    const res = await firstValueFrom(this.sucursalService.getByAddUrl_Riesgo('sucursal',this.sucursal));
    this.sucursales = res.map( o => ({...o, select: false}));
    this.sucursales2 = res.map( o => ({...o, select: false}));
  }
  formatearnormal(num){
    let cantidad = FuncionesRiesgo.formatearnormal(num);
    if(cantidad == "0.00"){
      cantidad ="0";
    }
    return cantidad;
  }

  private mesEnEspanol(m: moment.Moment): string {
    const mm = (m.month() + 1).toString().padStart(2, '0');
    return FuncionesMes.f_switchmes(mm);
  }
  async getObjetos(){
    this.perdida.InstitucionId = this.idInstitucion;
    this.perdida.Periodo = Number(this.getMes());
    this.perdida.NPeriodosHst= this.idInstitucion !== 1004 ? 13 : 8;
    this.perdida.NPeriodos = this.idInstitucion !== 1004 ? 13 : 8;
    this.perdida.ZonaId = -1;
    this.perdida.SucursalId = -1;
    this.perdida.ProductoId = -1;
    this.perdida.BnIntereses = this.bndInteres;

    this.matrizTransicion.InstitucionId = this.idInstitucion;
    this.matrizTransicion.Periodo = this.getMes();
    this.matrizTransicion.PeriodoAnterior = Number(moment(this.getMes(), 'YYYYMM').subtract(1,'month').format('YYYYMM'));
    this.matrizTransicion.TipoCreditoId = -1
    this.matrizTransicion.BnIntereses = this.bndInteres;
    this.matrizTransicion.ZonaId = -1;    
    this.matrizTransicion.ProductoId = -1;
    this.matrizTransicion.SectorId = -1;
    this.matrizTransicion.SucursalId = -1;
    this.matrizTransicion.AsesorId = -1;

    this.cosecha.InstitucionId = this.idInstitucion;
    this.cosecha.Periodo = this.periodo;
    this.cosecha.PAR = 30;
    this.cosecha.BnPAR_Inclusive = this.parInclusive;
    this.cosecha.NPeriodosHst= 12;

    this.concentracion.InstitucionId = this.idInstitucion;
    this.concentracion.Periodo = this.periodo;
    this.concentracion.ElementoAgrupador = 'EstatusCredito';

    this.concentracion2.InstitucionId = this.idInstitucion;
    this.concentracion2.Periodo = this.periodo;
    this.concentracion2.ElementoAgrupador = 'EstatusCredito';
    if(this.idInstitucion === 2){
      this.encGroup = 'Oficinas';
      this.concentracion2.ElementoAgrupador = 'Sector';
    }else{
      this.encGroup = 'Oficinas';
      this.concentracion2.ElementoAgrupador = 'Sucursal';
    }
    this.concentracion.NPeriodos = 1;
    this.concentracion.NDatosLimite= 3;
    this.mayoresdeudores.InstitucionId = this.idInstitucion;
    this.mayoresdeudores.Periodo = this.periodo;
    this.mayoresdeudores.NDatosLimite = this.numDeudores;
    this.mayoresdeudores.BnAgruparDatos= 1;

    await Promise.all([
      this.getPerdida(),
    ]);
    this.download = false;
  }
  // Tendencia
  multi = [];
  etiquetas = [];
  tipoSelecTendencia = typesApex.LINE
  colorScheme : any = ['#6BAED6', '#A6D9C9', '#C5B0D5', '#F7B267', '#FEE191', '#BFD8B8', '#A8CBE8', '#F6A6A1', '#8FD8D2', '#7BAEBE' ];
  xAxisLabel: string = 'Período';
  yAxisLabel: string[] = ['Monto'];
  showEtiquetas = false;
  suma_PerdidaEsperada = 0;
  suma_PerdidaNoEsperada95 = 0;
  suma_VaR95 = 0;
  suma_VaR95A = 0;
  carteraTotalD = 0;
  carteraTotalA = 0;

  textEd1Tendencia = 
    `El VaR de crédito nos permite cuantificar la máxima pérdida probable de una cartera de créditos a un periodo determinado, siendo la sumatoria da las pérdidas esperadas `
    +`y no esperadas.`
    +`\n`
    +`\n`
    +`Su cálculo se realiza mediante el método básico Basado en Calificaciones internas (IRB por sus siglas en inglés) tomando en cuenta el enfoque propuesto por el comité de `
    +`Basilea. En términos generales se realiza una distribución de todas las combinaciones posibles de pago y no pago en cada categoría de riesgos que permitan calcular la estimación `
    +`de la varianza (medida de dispersión que cuantifica cuánto se alejan los datos de su media o promedio) y así obtener la desviación estándar (raíz cuadrada de la varianza) para `
    +`este caso con un nivel de confianza del 95%.`;
  
  textEd2Tendencia;

  private async getPerdida(){
    try{
      const cartera = await firstValueFrom(this.concentracionService.getByAddUrl_Riesgo('concentracion',this.concentracion)); 
      this.carteraTotalD = cartera.reduce( (a,c) => a + c['Saldo_Actual'],0);
      var cop = JSON.parse(JSON.stringify(this.concentracion));
      cop.Periodo = moment(this.getMes(), 'YYYYMM').subtract(12, 'months').format('YYYYMM');
      const carteraA = await firstValueFrom(this.concentracionService.getByAddUrl_Riesgo('concentracion',cop)); 
      this.carteraTotalA = carteraA.reduce( (a,c) => a + c['Saldo_Actual'],0);
      const res = await firstValueFrom(this.perdidaService.getByAddUrl_Riesgo('perdida',this.perdida)); 
      this.construirArregloGraficaAreaLineal(res);
      await Promise.all([
        this.getCosechas(),
        this.getDeudores(),
        this.Funtion_matrizTransicion(),
        this.getConcentracion()
      ]);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  construirArregloGraficaAreaLineal(dataArr){
    this.multi = []
    this.etiquetas = [];
    this.showEtiquetas = false;
    let arrPerdidaEsperada: any[] = [];
    let arrPerdidaNoEsperada: any[] = [];
    let arrVar: any[] = [];
    let arraux: any[] = [];
    let dataSourceTable:any[] = [];
    var data1 = [];
    this.suma_PerdidaEsperada = 0;
    this.suma_PerdidaNoEsperada95 = 0;
    this.suma_VaR95 = 0;
    this.suma_VaR95A = 0;
    
    for(const data of dataArr){
      let fec = moment(data.Periodo, 'YYYYMM').format('MMMYY');
      this.etiquetas.push(fec);
      arraux.push(fec);
      dataSourceTable.push({"periodo":fec,"perdidaesperada":data['PerdidaEsperada'],"perdidanoesperada":data["PerdidaNoEsperada95"],"var90":data["VaR95"]});
      arrPerdidaEsperada.push(data['PerdidaEsperada']);
      arrPerdidaNoEsperada.push(data['PerdidaNoEsperada95']);
      arrVar.push(data['VaR95']);
      arraux.push(data['VaR95']);
      arraux.push(data['PerdidaNoEsperada95']);
      arraux.push(data['PerdidaEsperada']);
      
      if(data['Periodo'] == this.getMes()){
        this.suma_PerdidaEsperada += data['PerdidaEsperada'];
        this.suma_PerdidaNoEsperada95 += data['PerdidaNoEsperada95'];
        this.suma_VaR95 += data['VaR95'];
      }
      if(data['Periodo'] == moment(this.getMes(), 'YYYYMM').subtract(11, 'months').format('YYYYMM')){
        this.suma_VaR95A += data['VaR95'];
      }
      data1.push(arraux);
      arraux = [];
    }
    this.multi.push({name:'Var',data:arrVar.reverse()});
    this.multi.push({name:'Perdida no esperada',data:arrPerdidaNoEsperada.reverse()});
    this.multi.push({name:'Perdida esperada',data:arrPerdidaEsperada.reverse()});

    this.etiquetas = this.etiquetas.reverse();
    this.multi[0].data = this.multi[0].data;

    this.textEd2Tendencia = `A ${this.mesEnEspanol(this.dateReport.endOf('month'))} de ${this.dateReport.format('YYYY')} el VaR de crédito asciende a ${this.smMoneda} ${formatear.formatear(this.suma_VaR95, false)} `
    +`que representa el ${formatear.formatear(Number((this.suma_VaR95/this.carteraTotalD*100).toFixed(1)), true)}% `
    +`de la cartera de créditos (${this.smMoneda} ${formatear.formatear(this.carteraTotalD, false)}),  de los cuales ${this.smMoneda} ${formatear.formatear(this.suma_PerdidaEsperada, false)} `
    +`(${formatear.formatear(Number((this.suma_PerdidaEsperada/this.carteraTotalD*100).toFixed(1)), true)}%) y ${this.smMoneda} ${formatear.formatear(this.suma_PerdidaNoEsperada95, false)} `
    +`a pérdidas no esperadas (${formatear.formatear(Number((this.suma_PerdidaNoEsperada95/this.carteraTotalD*100).toFixed(1)), true)}%)`
    +`\n`
    +`\n`
    +`El VaR de crédito presenta un valor acumulado ${this.smMoneda} ${formatear.formatear(this.suma_VaR95A, false)} a ${this.mesEnEspanol(this.dateReport.endOf('month'))} de ${this.dateReport.format('YYYY')} con una participación del `
    +`${formatear.formatear(Number((this.suma_VaR95A/this.carteraTotalA*100).toFixed(1)), true)}% del total de la cartera de créditos (${this.smMoneda} ${formatear.formatear(this.carteraTotalA, false)})`
    +`. Esto implica un ${ this.suma_VaR95A<this.suma_VaR95?'crecimiendo':'decrecimiento'} de la pérdida máxima potencial de la cartera, lo cual indica que las acciones preventivas y correctivas `
    +`que estratégicamente ha venido tomando la sociedad como parte de su gestión ${ this.suma_VaR95A<this.suma_VaR95?'no':''} han mostrado un impacto positivo.`;
  }
  //Mtriz transición
  dataMatrices1 = [];
  dataMatrices2 = [];
  columnas;
  total_diagonal = [];
  total_abajodiagonal = [];
  total_arribadiagonal = [];
  total_diagonalII = [];
  total_abajodiagonalII = [];
  total_arribadiagonalII = [];
  
  textEd1Matriz = [];
  textEd2Matriz = [];
  textEd3Matriz = [];
  public async Funtion_matrizTransicion(){
    this.reloadElements = true;
    this.nombreSucursales = [];
    var data = [];
    this.matrizTransicion.SucursalId = -1;
    const res = await firstValueFrom(
      this.matrizTransicionService.getByAddUrl_Riesgo('matrizTR',this.matrizTransicion)
    );
      data.push(res);
    this.nombreSucursales.push('Consolidado');
    var dataS = [];
    for(const suc of this.sucursales){
      if(suc.select){
        this.matrizTransicion.SucursalId = suc.SucursalId;
        const res = await firstValueFrom(
          this.matrizTRFiltro.getByAddUrl_Riesgo('matrizTR/matriz-general',this.matrizTransicion)
        );
        this.nombreSucursales.push(suc.Nombre_Sucursal);
        data.push(res);
      }
    }
    this.ConvertirMatrizTransicionTabla(data);
    this.reloadElements = false;
  }
  public ConvertirMatrizTransicionTabla(dataArr){
    this.dataMatrices1 = [];
    this.dataMatrices2 = [];
    this.total_diagonal = [];
    this.textEd1Matriz = [];
    this.textEd2Matriz = [];
    this.textEd3Matriz = [];
    this.total_abajodiagonal = [];
    this.total_arribadiagonal = [];
    this.total_diagonalII = [];
    this.total_abajodiagonalII = [];
    this.total_arribadiagonalII = [];
    //primero verificar el número de row del arreglo 
    for(const data of dataArr){
      let auxM = [];
      let auxM2 = [];
      let rows = [];
      let columnas: any[] = [];
      for(const dato of data){
        if(!columnas.includes(dato['Nombre_CategoriaCredito_R'])){
          columnas.push(dato['Nombre_CategoriaCredito_R']);
        }
      }
      this.columnas = columnas;
      for(const dato of data){
        if(!rows.includes(dato['Renglon'])){
          rows.push(dato['Renglon']);
        }                                       
      }
      var total_diagonal = 0;
      var total_abajodiagonal = 0;
      var total_arribadiagonal = 0;
      var total_diagonalII = 0;
      var total_abajodiagonalII = 0;
      var total_arribadiagonalII = 0;
      var dataMatriz1 = [];
      var dataMatriz2 = [];
      for(const row of rows){
        const colums = data.filter(d => d['Renglon'] === row);
        var i=0, total = 0, total2 = 0;
        auxM = [];
        auxM2 = [];
        auxM.push(colums[0].Nombre_CategoriaCredito_R);
        auxM2.push(colums[0].Nombre_CategoriaCredito_R);

        colums.forEach( elem => {
          //Suma diagonales
          if(elem['Columna'] === elem['Renglon']){
            total_diagonal += Number(elem.Value)?Number(elem.Value):0;
            total_diagonalII += Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0
          }
          if(elem['Columna'] < elem['Renglon']){
            total_abajodiagonal += Number(elem.Value)?Number(elem.Value):0;
            total_abajodiagonalII += Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0
          }
          if(elem['Columna'] > elem['Renglon']){
            total_arribadiagonal += Number(elem.Value)?Number(elem.Value):0;
            total_arribadiagonalII += Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0
          }
          //Tabla de saldos
          auxM.push(Number(elem.Value)?
            {
              value:Number(elem.Value),
              idAct: elem.CategoriaCreditoId_C,
              idAnt: elem.CategoriaCreditoId_R
            }:
            {
              value:0,
              idAct: elem.CategoriaCreditoId_C,
              idAnt: elem.CategoriaCreditoId_R
            }
          );
          total += Number(elem.Value)?Number(elem.Value):0;
          //Tabla de créditos
          auxM2.push(Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0);
          total2 += Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0;

          i++;
        });
        auxM.push(Number(total.toFixed(2)));
        auxM2.push(total2);

        dataMatriz1.push(auxM);
        dataMatriz2.push(auxM2);
      }

      var suma = dataMatriz1.reduce((acum, fila) => {
        fila.slice(1).forEach((celda, j) => {
          acum[j] = (acum[j] ?? 0) + Number(celda?.value ?? celda ?? 0);
        });
        return acum;
      }, []);

      suma = ["Total", ...suma];
      const suma2 = dataMatriz2.reduce( (acum, fila) => 
        fila.map( (num, j) => ( (Number(acum[j]) || 0) + (Number(num) || 0) ) , [] )
      );
      suma2[0] = 'Total';

      dataMatriz1.push(suma);
      dataMatriz2.push(suma2);
      
      this.total_diagonal.push( Number((total_diagonal).toFixed(2)) );
      this.total_abajodiagonal.push( Number((total_abajodiagonal).toFixed(2)) );
      this.total_arribadiagonal.push( Number((total_arribadiagonal).toFixed(2)) );
      this.total_diagonalII.push( Number((total_diagonalII).toFixed(2)) );
      this.total_abajodiagonalII.push( Number((total_abajodiagonalII).toFixed(2)) );
      this.total_arribadiagonalII.push( Number((total_arribadiagonalII).toFixed(2)) );
      
      this.dataMatrices1.push(dataMatriz1);
      this.dataMatrices2.push(dataMatriz2);
    }
    this.dataMatrices1.forEach( (e, i) =>{
      this.textEd1Matriz.push(
        `A continuación, la matriz de transición ${i===0 ? 'del' : 'de'} ${this.nombreSucursales[i]} muestra un saldo de cartera de créditos total de `
        +`${this.smMoneda} ${formatear.formatear(
          this.dataMatrices1[i][this.dataMatrices1[i].length - 1][this.dataMatrices1[i][this.dataMatrices1[i].length - 1].length - 1],
          false
        )} `
        +`a ${this.mesEnEspanol(this.dateReport.clone().subtract(1,'month'))} de ${this.dateReport.clone().subtract(1,'month').format('YYYY')} y la transición de las calificaciones de esos créditos a ${this.mesEnEspanol(this.dateReport)} ${this.dateReport.format('YYYY')}.`
      );
      this.textEd2Matriz.push(
        `La matriz de transición por saldos ${i===0 ? 'del' : 'de'} ${this.nombreSucursales[i]} nos muestra que, los saldos con mejora corresponden a un monto de `
        +`${this.smMoneda} ${this.formatearnormal(this.total_abajodiagonal[i])} con un ${ this.formatearnormal(Number((this.total_abajodiagonal[i] / this.dataMatrices1[i][this.dataMatrices1[i].length - 1][this.dataMatrices1[i][this.dataMatrices1[i].length - 1].length - 1] *100)
          .toFixed(1)))}% de participación sobre el saldo total de la cartera de crédito `
        +`${i===0 ? 'del' : 'de'} ${this.nombreSucursales[i]}. Por su parte, los saldos con deterioro presentan un monto global de ${this.smMoneda} ${this.formatearnormal(this.total_arribadiagonal[i])}`
        +` representando el ${ this.formatearnormal(Number((this.total_arribadiagonal[i] / this.dataMatrices1[i][this.dataMatrices1[i].length - 1][this.dataMatrices1[i][this.dataMatrices1[i].length - 1].length - 1] *100).toFixed(1)))}% del total de la cartera, mostrando una ${this.total_arribadiagonal[i] > this.total_abajodiagonal[i]
        ?'mayor':'menor'} proporción de créditos con deterioro frente a los saldos con mejora. En cuanto a los saldos que no presentaron cambios en la calificación de origen a `
        +`${this.mesEnEspanol(this.dateReport)} de ${this.dateReport.format('YYYY')}, el monto corresponde a ${this.smMoneda} ${this.formatearnormal(this.total_diagonal[i])} con el `
        +`${ this.formatearnormal(Number((this.total_diagonal[i] / this.dataMatrices1[i][this.dataMatrices1[i].length - 1][this.dataMatrices1[i][this.dataMatrices1[i].length - 1].length - 1] *100).toFixed(1)))}% del total de la cartera.`
      );
      this.textEd3Matriz.push(
        `La misma matriz de transición analizada por el número total de créditos ${i===0 ? 'del' : 'de'} ${this.nombreSucursales[i]} correspondiente a `
        +`${formatear.formatear(this.dataMatrices2[i][this.dataMatrices2[i].length - 1][this.dataMatrices2[i][this.dataMatrices2[i].length - 1].length - 1
        ], false)} operaciones, evidencia que a ${this.mesEnEspanol(this.dateReport)} de ${this.dateReport.format('YYYY')} son `
        +`${this.formatearnormal(this.total_abajodiagonalII[i])} créditos los que presentan mejora, correspondiendo al ${ this.formatearnormal(Number((this.total_abajodiagonalII[i] 
        / this.dataMatrices2[i][this.dataMatrices2[i].length - 1][this.dataMatrices2[i][this.dataMatrices2[i].length - 1].length - 1] *100).toFixed(1)))}% sobre el `
        +`número total de créditos. El número de créditos con deterioro corresponde a ${this.formatearnormal(this.total_arribadiagonalII[i])} representando el `
        +`${ this.formatearnormal(Number((this.total_arribadiagonalII[i] / this.dataMatrices2[i][this.dataMatrices2[i].length - 1][this.dataMatrices2[i][this.dataMatrices2[i]
        .length- 1].length - 1] *100).toFixed(1)))}% del volumen total de cartera, mostrando una ${this.total_arribadiagonalII[i] > this.total_abajodiagonalII[i]?'mayor':'menor'} proporción `
        +`de créditos con deterioro frente a los que han mostrado mejoría. En cuanto al número de créditos que no presentaron cambio en la calificación, estos corresponden a `
        +`${this.formatearnormal(this.total_diagonalII[i])} con el ${ this.formatearnormal(Number((this.total_diagonalII[i] / this.dataMatrices2[i][
        this.dataMatrices2[i].length - 1][this.dataMatrices2[i][this.dataMatrices2[i].length- 1].length - 1] *100).toFixed(1)))}% de participación sobre el total.`
      );
    });
  }
  public PintarCelda(x,y){
    if (y == this.columnas.length)
      return "";
    if(x == y){
      return "w3-light-gray"
    }
    if(x > y){
      return "w3-orange2"
    }
    if(x < y){
      return "w3-light-green2"
    }else
      return '';
  }
  private PintarCeldaC(x,y){
    if (y == this.columnas.length)
      return "";
    if(x == y){
      return "#f1f1f1"
    }
    if(x > y){
      return "#FBCDBA"
    }
    if(x < y){
      return "#C8E3BB"
    }else
      return '#eeeeee';
  }
  //Cosechas consultas
  porPorcent = true;
  dataBarrasMor = [];
  nombres_mes = [];
  dataSource = [];
  dataCosechasAll = [];
  tipoSelecCosecha = typesApex.LINE;
  textEd1Cosechas = [];
  etiquetasCosechas = [];
  async getCosechas(){
    this.reloadElements = true;
    this.dataCosechasAll = [];
    this.nombreSucursales2 = [];
    try{
      this.cosecha.SucursalId = undefined;
      const res = await firstValueFrom(this.cosechaService.getByAddUrl_Riesgo('cosechas',this.cosecha));
      this.nombreSucursales2.push('Consolidado');
      this.dataCosechasAll.push(res);
      for(const suc of this.sucursales2){
        if(suc.select){
          this.cosecha.SucursalId = suc.SucursalId;
          const res = await firstValueFrom(this.cosechaService.getByAddUrl_Riesgo('cosechas',this.cosecha));
          this.nombreSucursales2.push(suc.Nombre_Sucursal);
          this.dataCosechasAll.push(res);
        }
      }
      this.getDataCosechas();
      this.reloadElements = false;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public getDataCosechas(){
    this.dataSource = [];
    this.dataBarrasMor = [];
    for(const arreglo of this.dataCosechasAll){
      var aux = [];
      if(!this.porPorcent){
        for(var i =0; i <arreglo.length; i++){
          aux.push({periodo: arreglo[i].Periodo, cosecha: arreglo[i].FechaCosecha, colocacion: arreglo[i].ColocacionCosecha, saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].Mora});
        }
      }else{
        for(var i =0; i <arreglo.length; i++){
          aux.push({periodo: arreglo[i].Periodo, cosecha: arreglo[i].FechaCosecha, colocacion: arreglo[i].ColocacionCosecha, saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].MorosidadSaldo*100});
        }
      }
      this.graficas_lineales(aux);
      var j=0;
      var aux2 = [];
      if(!this.porPorcent){
        for(var i =0; i <aux.length; i++){
          if( i>0){
            if(aux[i].cosecha == aux[(i-1)].cosecha){
              aux2[(j)].series.push( {periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha, saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].Mora} );
            }else{
              aux2.push({cosecha: aux[(i)].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha, saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].Mora }]});
              j++
            }
          }else{
            aux2.push({cosecha: aux[i].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha, saldo: arreglo[i].Saldo_Actual, mora: arreglo[i].Mora }]});
          }
        }
      }else{
        for(var i =0; i <aux.length; i++){
          if( i>0){
            if(aux[i].cosecha == aux[(i-1)].cosecha){
              aux2[(j)].series.push( {periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha, saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadSaldo*100).toFixed(2))} );
            }else{
              aux2.push({cosecha: aux[(i)].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha, saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadSaldo*100).toFixed(2)) }]});
              j++;
            }
          }else{
            aux2.push({cosecha: aux[i].cosecha, series: [{periodo: arreglo[i].Periodo, colocacion: arreglo[i].ColocacionCosecha, saldo: arreglo[i].Saldo_Actual, mora: Number((arreglo[i].MorosidadSaldo*100).toFixed(2)) }]});
          }
        }
      }    
      aux2.sort( (a,b) => moment(a.cosecha).valueOf() - moment(b.cosecha).valueOf() );
      for(const p of aux2){
        p.series.sort( (a,b) => a.periodo - b.periodo);
      }
      this.datosTablacosecha(aux2);
    }
  }
  private graficas_lineales(arreglo: any){
    var auxFinal = [];
    const info = [...arreglo];
    info.sort( (a,b) => moment(b.cosecha).diff(moment(a.cosecha)) );
    const periodos = [ ...new Set(info.map( item => item.cosecha)) ];
    periodos.forEach( per => {
      const dat = info.filter( i => i.cosecha === per);
      dat.sort( (a,b) => b.periodo-a.periodo)
      const data = dat.map( e => e.mora);
      auxFinal.push({
        name: moment(per).format('MMM YY'),
        data: data
      });
    });
    this.dataBarrasMor.push(auxFinal);
    this.etiquetasCosechas = periodos.map( e => moment(e).format('MMMYY'))
  }
  private datosTablacosecha(arreglo: any){
    var aux = [];
    this.nombres_mes = [];
    if(arreglo.length != 0){
      for(var i=0; i<arreglo[0].series.length; i++){
        this.nombres_mes.push(moment(arreglo[0].series[i].periodo, 'YYYYMM').format('MMM YY').toLocaleLowerCase());
      }
      for(var i =0; i <arreglo.length; i++){
        aux.push({cosecha: moment(arreglo[i].cosecha).format('MMM YY').toLocaleLowerCase(), montocolocado: arreglo[i].series[0].colocacion,
          meses:[this.asignacion(i,1,arreglo),this.asignacion(i,2,arreglo),this.asignacion(i,3,arreglo),this.asignacion(i,4,arreglo),this.asignacion(i,5,arreglo),this.asignacion(i,6,arreglo),
            this.asignacion(i,7,arreglo),this.asignacion(i,8,arreglo),this.asignacion(i,9,arreglo),this.asignacion(i,10,arreglo),this.asignacion(i,11,arreglo),this.asignacion(i,12,arreglo)
          ],});
      }
    }  
    this.dataSource.push(aux);
  }
  private asignacion(i: any, nm: any, arreglo: any){
    if((arreglo[i].series.length-nm)>=0){
      return arreglo[i].series[arreglo[i].series.length-nm].mora;
    }
    else{
      return '';
    }
  }
  //concentración
  etiquetasConcentracion = [];
  dataConcentracion = [];
  typeConcentracion = typesApex.COMBO;
  encGroup = '';
  textEd1Concentracion = '';
  private async getConcentracion(){
    try{
      const res = await firstValueFrom(this.concentracionService.getByAddUrl_Riesgo('concentracion',this.concentracion2)); 
      var aux = [];
      for(let p of res){
        aux.push(p);
      }
      this.getDataConcentracion(aux);
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  private getDataConcentracion(arreglo){
    arreglo = arreglo.sort((a,b) => b.Periodo - a.Periodo);
    const info = [...arreglo];
    const periodos = [ ...new Set(info.map( item => item.Periodo)) ];
    const elemAgrup = [ ...new Set(info.map( item => item.ElementoAgrupador)) ];
    this.etiquetasConcentracion = elemAgrup.map(e => e);
    var auxFinal = []
    elemAgrup.forEach( ele => {
      const dat = periodos.map(p => {
        const found = info.find(i => i.ElementoAgrupador === ele && i.Periodo === p);
        return found ? found.Saldo_Actual : 0; // Valor por defecto si no existe
      });
      auxFinal.push(dat[0])
    });
    const monto = auxFinal.reduce( (acum, actual) => acum+actual, 0);
    const porcentajes = auxFinal.map( d => {return Number((d/monto*100).toFixed(1))});
    this.dataConcentracion = [{name: 'Monto',data: auxFinal}, {name: 'Porcentaje',data: porcentajes}];
    
    var text = '';
    for(var i=0; i<3; i++){
      text += `"${this.etiquetasConcentracion[i]}" con el ${this.dataConcentracion[1].data[i]} %`;
      switch(i){
        case 0:
          text += ` seguido de `;
          break;
        case 1:
          text += ` y de `;
          break;
      }
    }
    this.textEd1Concentracion = `${this.encGroup==='Sector'?'El '+this.encGroup:'Las '+this.encGroup} que registran la mayor exposición crediticia son `
          +text+`, como se muestra en la siguiente gráfica: `;
  }
  //Deudores
  numDeudores = 20;
  etiquetasDeudores = [];
  grafDeudores = [];
  typeDeudores = typesApex.DONUT;
  tablaDeudores = [];
  encabezadosTabla = [];
  valorDeudores = 0;
  textEd1Deudores = '';
  public async getDeudores(){
    try{
      this.reloadElements = true;
      this.tablaDeudores = [];
      this.grafDeudores = [];
      this.encabezadosTabla = [];
      this.etiquetasDeudores = [];
      this.mayoresdeudores.NDatosLimite = this.numDeudores;
      const res = await firstValueFrom(this.mayoresdeudoresService.getByAddUrl_Riesgo('mayoresDeudores',this.mayoresdeudores));
      var aux = [];
      for(var i = 1; i<5; i++){
        this.encabezadosTabla.push(this.translate.instant('riesgo-credito.reporte.titulo-deudores-'+i));
        if(i===2)
          this.encabezadosTabla.push(this.translate.instant('riesgo-credito.reporte.titulo-deudores-'+i+'-1'));
      }
      this.etiquetasDeudores = ['Mayores deudores', 'Cartera restante']
      var tam = this.numDeudores+1;
      if(tam > res.length ){
        tam = res.length;
      }
      for(var i= 0; i<tam; i++){
        if(res[i]['Nombre_Socio'] != 'Sin Datos')
          aux.push({name: res[i]['Nombre_Socio'], value: res[i]['Saldo_Actual'], clave: res[i]['Clave_Socio']});
      }
      const tot = aux.reduce( (acum, actual) => acum+actual.value,0 );
      this.tablaDeudores = aux.map( e => {
        return {
          ...e,
          porcentaje: Number((e.value/tot*100).toFixed(1)),
        }
      });
      this.grafDeudores = [
        {name: '', data: [tot, this.carteraTotalD-tot]},
      ];
      this.valorDeudores = tot;
      this.reloadElements = false;
      this.textEd1Deudores = 
      `Los ${this.numDeudores} mayores deudores concentran el ${Number((this.valorDeudores/this.carteraTotalD*100).toFixed(1))}% de la cartera de créditos total `
      +`a ${this.mesEnEspanol(this.dateReport)} ${this.dateReport.format('YYYY')}, con una exposición acumulada entre estos de ${this.smMoneda} ${this.formatearnormal(this.valorDeudores)}, `
      +`ubicándose por ${Number((this.valorDeudores/this.carteraTotalD*100).toFixed(1))>20?'encima':'debajo'} del límite establecido del 20 %. `
      +`\n`
      +`\n`
      +`A continuación, se muestra la tabla de referencia con los ${this.numDeudores} mayores deudores: `;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /** Pintado de la tabla */
  pintar(pos: any, col: any){    
    if(pos == col)
      return "w3-grey-per ";
    if(pos > col)
      return "w3-light-grey ";
    else
      return '';
  }
  pintarC(pos: any, col: any){    
    if(pos == col)
      return '#E7E6E6';
    if(pos > col)
      return '#f1f1f1';
    else
      return '';
  }
  colorText(num){
    var aux='';
    if(this.porPorcent && num != undefined){
      if(num > 0 && num <= 5)
        return ''//'#5AB436'//'#72D54A'
      else if(num > 5 && num <= 10)
        return ''//'#F2C806'//'#FFD100'
      else if( num > 10)
        return '#FF495C'//'#FF495C' '#CF1A2D'
      else
        return '';
    }else
      return '';
  }
  pintarPorcent(num){
    var aux = ''+num;
    if(aux != '')
      return true;
    return false;
  }
  //EXPORTAR PDF
  public async generarPDF() {
    try{
      moment.locale('es');
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const tendencia = this.tendenciaA?await this.tendenciaText():[];
      const matriz = this.matrizA?await this.matrizText():[];
      const cosechas = this.cosechasA?await this.cosechasText():[];
      const concentracion = this.concentracionA?await this.concentracionText():[];
      const deudores = this.deudoresA?await this.deudoresText():[];
      const conclusiones = this.conclusionesA&&this.textEd1Conclusiones!==''?await this.conclusionesText():[];

      const docPDF = {
        pageSize: 'A4',
        pageMargins: [40, 100, 40, 60],
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
          logoHeader: ConstantesImagenes.logoHeader,
          coverWave: ConstantesImagenes.coverWave,
          iconMejora: ConstantesImagenes.iconMejora,
          iconDeterioro: ConstantesImagenes.iconDeterioro,
          iconSinCambio: ConstantesImagenes.iconSinCambio,
        },
        defaultStyle: {
          font: 'Roboto',
          fontSize: 11
        },
        header: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          return {
            columns: [
              {
                image: 'logoHeader',
                width:20,
                alignment: 'left',
                margin: [40, 30, 0, 0],
              },
              { text: '', width: '*' },
            ]
          };
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          this.portada(),
          { text: '', pageBreak: 'after' },
          this.tablaContenido(),
          { text: '', pageBreak: 'after' },
          this.introductionText(),
          tendencia,
          matriz,
          cosechas,
          concentracion,
          deudores,
          conclusiones,
        ]
      }

      var reportName = 'Reporte riegos';
      const pdf = pdfMake.createPdf(docPDF);
      await pdf.download(reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
    }catch(error){
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  //Tabla de contenido
  private tablaContenido(){
    return [
      {
        text: `TABLA DE CONTENIDO`,
        style: 'header',
        bold: true,
        fontSize: 18,
        color: '#949393',
        margin: [0, 40, 0, 20],
      },
      {
        toc: {
          textStyle: { fontSize: 12, color: '#949393' },
          numberStyle: { fontSize: 12, color: '#949393' },
          textMargin: [0, 6, 0, 6],
        }
      },
    ]
  }
  //Portada
  private portada(){
    return [
      {
        image: 'coverWave',
        width: 595,
        height: 170,
        absolutePosition: { x: 0, y: 671.89 },
      },
      {
        image: 'logoHeader',
        width: 110,
        absolutePosition: { x: 242.64, y: 187 },
      },
      {
        text: this.nombreInstitucion,
        style: 'header',
        bold: true,
        fontSize: 26,
        color: '#000000',
        alignment: 'right',
        margin: [0, 252, 0, 0],
      },
      {
        text: this.translate.instant('riesgo-credito.reporte.portada-1'),
        style: 'header',
        bold: true,
        fontSize: 20,
        color: '#000000',
        alignment: 'right',
        margin: [0, 45, 0, 0],
      },
      {
        text: `${this.translate.instant('riesgo-credito.reporte.portada-3')} ${this.mesEnEspanol(this.dateReport)}, ${this.dateReport.format('YYYY')}`,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#949393',
        alignment: 'right',
        margin: [0, 2, 0, 0],
      },
      {
        text: this.translate.instant('riesgo-credito.reporte.portada-2'),
        style: 'header',
        bold: true,
        fontSize: 18,
        color: '#000000',
        alignment: 'right',
        margin: [0, 25, 0, 0],
      },
      {
        text: [
          `Friedrich Consulting Group y sus empresas filiales, así como el ecosistema Aleema® no se hacen responsables de la veracidad, integridad, `,
          `ni confiabilidad de la información proporcionada por la ${this.nombreInstitucion}, la cual ha sido utilizada como base para `,
          `los cálculos y análisis contenidos en el presente documento. La validación, precisión y actualidad de los datos son de exclusiva responsabilidad de la fuente original.`,
        ],
        style: 'header',
        bold: false,
        fontSize: 8,
        color: '#000000',
        width: 495,
        absolutePosition: { x: 60, y: 610 },
      },
    ]
  }
  //Introducción
  private introductionText(){
    return [
      {
        text: `A. REPORTE DE RIESGO DE CRÉDITO`,
        tocItem: true,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#000000',
        margin: [0, 30, 0, 0],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#000000'
          }
        ],
        margin: [0, 5, 0, 20]
      },
      {
        text: [
          `El presente documento contiene los resultados del análisis de riesgo crediticio, incluyendo aspectos tanto cualitativos como cuantitativos al cierre del mes `,
          `de ${this.mesEnEspanol(this.dateReport.endOf('month'))} ${this.dateReport.format('YYYY')} correspondiente a la ${this.nombreInstitucion}, mismos que se monitorean a través del ecosistema Aleema\u00AE `,
          `de forma mensual (cifras expresadas en ${this.moneda}).`,
          `\n`,
          `\n`,
          `La medición del riesgo de crédito consiste en cuantificar las pérdidas derivadas de la actividad crediticia de una institución financiera, evaluando la probabilidad de `,
          `incumplimiento de pago, las causas del deterioro de la cartera de crédito, así como su impacto en la situación financiera en la gestión global.`,
          `\n`,
          `\n`,
          `El objetivo del análisis de pérdidas de la cartera de créditos es en primera instancia apoyar en la gestión de cobranza y en la toma de decisiones argumentadas y oportunas `,
          `con la finalidad de anticipar posibles riesgos de incobrabilidad y de esta forma mantener niveles adecuados de la rentabilidad y liquidez.`,
          `\n`,
          `\n`,
          `Los métodos utilizados para la medición del riesgo de crédito, que se presentan a continuación son: cálculo del VaR (pérdidas esperadas y no esperadas), matriz de transición, `,
          `concentraciones y concentración de mayores deudores.`,
          `\n`,
          `\n`,
          ``,
        ],
        alignment: 'justify',
        fontSize: 11,
        color: '#000000',
      },
    ]
  }
  //tendencia
  private async tendenciaText(){
    const comp = this.grafCmp.find(g => g.zona === 1);
    const img = await comp.exportImgBlob();
    return [
      {
        text: `B. Valor en Riesgo (VaR): pérdidas esperadas y no esperadas`,
        tocItem: true,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#000000',
        margin: [0, 30, 0, 0],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#000000'
          }
        ],
        margin: [0, 5, 0, 20]
      },
      {
        text: [
          this.textEd1Tendencia
        ],
        alignment: 'justify',
        fontSize: 11,
        color: '#000000',
      },
      img,
      {
        text: [
          this.textEd2Tendencia
        ],
        alignment: 'justify',
        fontSize: 11,
        color: '#000000',
      },
    ]
  }
  //Matriz transición
  private async matrizText(){
    var matrices = await this.matrizTablas();
    return [
      {
        text: `C. MATRICES DE TRANSICIÓN`,
        tocItem: true,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#000000',
        margin: [0, 30, 0, 0],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#000000'
          }
        ],
        margin: [0, 5, 0, 20]
      },
      {
        text: [
          `La matriz de transición en el contexto del riesgo de crédito es una herramienta que nos permite modelar y analizar la evolución de las calificaciones o categorías de `,
          `riesgo de un crédito en un periodo de tiempo determinado.`,
          `\n`,
          `\n`,
          `En donde las categorías de riesgo utilizadas por la institución son las siguientes:`,
          `\n`,
          `\n`,
          `De igual manera nos permiten prever posibles pérdidas y hacer un pronóstico de incumplimientos, estimando cómo evoluciona la calidad de la cartera crediticia, posibilitándonos `,
          `a tomar mejores decisiones y acciones en cuanto al manejo del riesgo de crédito.`,
          `\n`,
          `\n`,
          `Visualmente, a través de las matrices de transición identificamos la evolución de las calificaciones de riesgo crediticio a lo largo del tiempo, analizando la probabilidad que `,
          `un prestatario o grupo de prestatarios migre de un nivel de riesgo a otro en el periodo de tiempo que se ha definido.`,
          `\n`,
          `\n`,
          `En donde las celdas marcadas en gris, es decir la diagonal de la matriz, corresponde a los créditos que no registran cambio de un periodo a otro; las celdas por encima de la `,
          `diagonal marcadas en rojo corresponden a los créditos que tuvieron un deterioro y las celdas por debajo de la diagonal marcadas en verde son los créditos que presentan una `,
          `mejora en relación con el periodo anterior.`,
          `\n`,
          `\n`,
        ],
        alignment: 'justify',
        fontSize: 11,
        color: '#000000',
      },
      ... matrices
    ]
  }
  private async matrizTablas() {
    const tabs = [];

    for (let i = 0; i < this.dataMatrices1.length; i++) {
      const t = await this.generateTableMatrizSaldosPDF(this.dataMatrices1[i]);
      const tar = await this.generateTargets(1,i);
      let t2 = [], tar2 = [];
      if (this.tabla2) {
        t2 = await this.generateTableMatrizCuentasPDF(this.dataMatrices2[i]);
        tar2 = await this.generateTargets(2,i);
      }
      tabs.push(
        {
          text: [`MATRIZ DE TRANSICIÓN | SALDOS | `,{ text: this.nombreSucursales[i], color: i===0?'#000000':'#0070C0' },],
          style: 'header',
          bold: true,
          fontSize: 11,
          color: '#000000',
          margin: [0, 30, 0, 0],
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
              lineColor: '#000000',
            },
          ],
          margin: [0, 5, 0, 20],
        },
        {
          text: [
            this.textEd1Matriz[i],
            `\n`,
            `\n`,
          ],
          alignment: 'justify',
          fontSize: 11,
          margin: [0, 5, 0, 0],
          color: '#000000',
        },
        ...t,
        ...tar,
        {
          text: [
            this.textEd2Matriz[i],
            `\n`,
            `\n`,
          ],
          alignment: 'justify',
          fontSize: 11,
          margin: [0, 5, 0, 0],
          color: '#000000',
        },
        ...t2,
        ...tar2,
        this.tabla2?{
          text: [
            this.textEd3Matriz[i]
          ],
          alignment: 'justify',
          fontSize: 11,
          margin: [0, 5, 0, 0],
          color: '#000000',
        }:[],
      );
    }
    return tabs;
  }
  private async generateTableMatrizSaldosPDF(tab){
    var headers = [];
    var data = [];

    const h1 = [
      {text: '', col: 1},
      ...this.dataMatrices1[0].flatMap( e => { return {
        text: e[0], col: 1, fontSize: 5
      }})
    ];

    headers.push(h1);
    var data = [];
    tab.forEach( (d, i) =>{
      var aux = [];
      d.forEach( (n, j) =>{
        if(j===0){
          aux.push({
            text: `${n}`,
            fontGround: '#eeeeee',
            border: undefined,
            border_color: undefined,
            fontSize: 5,
          })
        }else if(j == d.length-1 || i == tab.length-1){
          aux.push({
            text: `${this.formatearnormal(n.toFixed(2))}`,
            fontGround: this.PintarCeldaC(j-1,i),
            border: undefined,
            border_color: undefined,
            fontSize: 5,

          })
        }else{
          if(n.value === 0){
            aux.push({
              text: ``,
              fontGround: this.PintarCeldaC(j-1,i),
              border: undefined,
              border_color: undefined,
              fontSize: 5,

            })
          }else{
            aux.push({
              text: `${this.formatearnormal(n.value)}`,
              fontGround: this.PintarCeldaC(j-1,i),
              border: undefined,
              border_color: undefined,
              fontSize: 5,

            })
          }
        }
      })
      data.push(aux);
    });
    const ta = await generatePDF.table(headers, data);
    return [ta];
  }
  private async generateTableMatrizCuentasPDF(tab){
    var headers = [];
    var data = [];

    const h1 = [
      {text: '', col: 1},
      ...this.dataMatrices2[0].flatMap( e => { return {
        text: e[0], col: 1, fontSize: 7
      }})
    ];

    headers.push(h1);
    var data = [];
    tab.forEach( (d, i) =>{
      var aux = [];
      d.forEach( (n, j) =>{
        if(j===0){
          aux.push({
            text: `${n}`,
            fontGround: '#eeeeee',
            border: undefined,
            border_color: undefined,
            fontSize: 7,
          })
        }else{
          if(n.value !== 0){
            aux.push({
              text: `${this.formatearnormal(n)}`,
              border: undefined,
              border_color: undefined,
              fontSize: 7,

            })
          }else{
            aux.push({
              text: ``,
              border: undefined,
              border_color: undefined,
              fontSize: 7,

            })
          }
        }
      })
      data.push(aux);
    });
    const ta = await generatePDF.table(headers, data);
    return [ta];
  }
  private async generateTargets(tab: number, pos: number){
    var t1;
    var t2;
    var t3;
    var sum = 0
    switch(tab){
      case 1:
        t1 = this.total_abajodiagonal[pos];
        t2 = this.total_diagonal[pos];
        t3 = this.total_arribadiagonal[pos];
        break;
      case 2:
        t1 = this.total_abajodiagonalII[pos];
        t2 = this.total_diagonalII[pos];
        t3 = this.total_arribadiagonalII[pos];
        sum = 3;
        break;
    }
    const cards = [
    {
      columns: [
        {
          width: '*',
          stack: [
            { text: `${this.translate.instant('riesgo-credito.matriz.tarj'+(1+sum))}`, color: '#8B8E93', bold: true, fontSize: 10 },
            {
              columns: [
                { image: 'iconMejora', width: 16, margin: [0, 3, 0, 0] },
                { text: `${tab===1?this.smMoneda:''} ${this.formatearnormal(t1)}`, color: '#8bc34a', fontSize: 12, bold: true, margin: [4, 0, 0, 0] }
              ],
              columnGap: 2
            },
            { text: `${this.mesEnEspanol(this.dateReport)} • ${this.dateReport.format('YYYY')}`, color: '#888', fontSize: 8 }
          ],
          margin: [5, 5, 5, 5],
          fillColor: '#F9FFF9',
          border: [true, true, true, true]
        },
        {
          width: '*',
          stack: [
            { text: `${this.translate.instant('riesgo-credito.matriz.tarj'+(2+sum))}`, color: '#8B8E93', bold: true, fontSize: 10 },
            {
              columns: [
                { image: 'iconSinCambio', width: 16, margin: [0, 3, 0, 0] },
                { text: `${tab===1?this.smMoneda:''} ${this.formatearnormal(t2)}`, color: '#0075C9', fontSize: 12, bold: true, margin: [4, 0, 0, 0] }
              ],
              columnGap: 2
            },
            { text: `${this.mesEnEspanol(this.dateReport)} • ${this.dateReport.format('YYYY')}`, color: '#888', fontSize: 8 }
          ],
          margin: [5, 5, 5, 5],
          fillColor: '#F9FBFF',
          border: [true, true, true, true]
        },
        {
          width: '*',
          stack: [
            { text: `${this.translate.instant('riesgo-credito.matriz.tarj'+(3+sum))}`, color: '#8B8E93', bold: true, fontSize: 10 },
            {
              columns: [
                { image: 'iconDeterioro', width: 16, margin: [0, 3, 0, 0] },
                { text: `${tab===1?this.smMoneda:''} ${this.formatearnormal(t3)}`, color: '#ff9012', fontSize: 12, bold: true, margin: [4, 0, 0, 0] }
              ],
              columnGap: 2
            },
            { text: `${this.mesEnEspanol(this.dateReport)} • ${this.dateReport.format('YYYY')}`, color: '#888', fontSize: 8 }
          ],
          margin: [5, 5, 5, 5],
          fillColor: '#FFF9F5',
          border: [true, true, true, true]
        },
      ],
      columnGap: 10
    }
  ];
    return cards;
  }
  // cosechas
  private async cosechasText(){
    return [
      {
        text: `D. COSECHAS`,
        tocItem: true,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#000000',
        margin: [0, 30, 0, 0],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#000000'
          }
        ],
        margin: [0, 5, 0, 20]
      },
      {
        text: [
          `El análisis de cosechas de crédito es una metodología que evalúa el comportamiento histórico de grupos de préstamos (cosechas) desembolsados en un mismo período de tiempo `,
          `para medir la evolución del riesgo crediticio. Permite identificar tendencias, patrones de morosidad y la efectividad de las políticas de crédito al comparar el desempeño `,
          `de diferentes cosechas a lo largo del tiempo. Este análisis ayuda a tomar decisiones informadas para mejorar las estrategias de gestión del riesgo y optimizar el `,
          `rendimiento de la cartera`,
          `\n`,
          `\n`,
        ],
        alignment: 'justify',
        fontSize: 11,
        color: '#000000',
      },
      ... await this.getTablasOrGraph()
    ];
  }
  private async getTablasOrGraph(){
    const data = [];
    for(let i = 0; i < this.dataSource.length; i++){
      var imp = await this.generateTablaCosechas(this.dataSource[i])
      var tab;
      if(this.tablaCosechas){
        const comp = this.grafCmp.find(g => g.zona === 30+i);
        tab = await comp.exportImgBlob();
      }
      data.push(
        {
          text: [`COSECHAS | PORCENTAJES DE MORA |`,{ text: this.nombreSucursales2[i], color: i===0?'#000000':'#0070C0' },],
          style: 'header',
          bold: true,
          fontSize: 14,
          color: '#000000',
          margin: [0, 30, 0, 0],
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
              lineColor: '#000000'
            }
          ],
          margin: [0, 5, 0, 20]
        },
        imp,
        tab,
        this.textEd1Cosechas[i],
      );
    }
    return data;
  }
  private async generateTablaCosechas(tab){
    var headers = [];

    const h1 = [
      {text: `${this.translate.instant('riesgo-credito.cosechas.tit1')}`, col: 1, fontSize: 5},
      {text: `${this.translate.instant('riesgo-credito.cosechas.tit2')}`, col: 1, fontSize: 5},
      ...this.nombres_mes.flatMap( (e, i) => { return {
        text: e, col: 1, fontSize: 5
      }}).reverse()
    ];
    if(this.nombres_mes.length<12){
      for(var i = 0; i< (12-this.nombres_mes.length); i++){
        h1.push(
          {text: ``, col: 1, fontSize: 5},
        );
      }
    }
    headers.push(h1);
    var data = [];
    tab.forEach( (d, i) =>{
      var aux = [];
      aux.push({
        text: `${d.cosecha}`,
        fontGround: '',
        border: undefined,
        border_color: undefined,
        fontSize: 5,
      });
      aux.push({
        text: `${this.formatearnormal(d.montocolocado)}`,
        fontGround: '',
        border: undefined,
        border_color: undefined,
        fontSize: 5,
      });
      d.meses.forEach( (n, j) =>{
        if(this.pintarPorcent(d)){
          aux.push({
            text: `${this.formatearnormal(n)}`,
            fontGround: this.pintarC(i,11-j),
            border: undefined,
            border_color: undefined,
            fontSize: 5,
            color: this.colorText(n),
          });
        }
      })
      data.push(aux);
    });
    const ta = await generatePDF.table(headers, data);
    return [ta];
  }
  //Concentración
  private async concentracionText(){
    const comp = this.grafCmp.find(g => g.zona === 50);
    const imp = await comp.exportImgBlob();

    var text = '';
    for(var i=0; i<3; i++){
      text += `"${this.etiquetasConcentracion[i]}" con el ${this.dataConcentracion[1].data[i]} %`;
      switch(i){
        case 0:
          text += ` seguido de `;
          break;
        case 1:
          text += ` y de `;
          break;
      }
    }
    return [
      {
        text: `E. CONCENTRACIÓN`,
        tocItem: true,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#000000',
        margin: [0, 30, 0, 0],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#000000'
          }
        ],
        margin: [0, 5, 0, 20]
      },
      {
        text: [
          this.textEd1Concentracion
        ],
        alignment: 'justify',
        fontSize: 11,
        color: '#000000',
      },
      imp
    ];
  }
  //Deudores
  private async deudoresText(){
    const comp = this.grafCmp.find(g => g.zona === 60);
    const imp = await comp.exportImgBlob();
    const tab = await this.getTablaDeudores();
    return [
      {
        text: `F. ${this.numDeudores} MAYORES DEUDORES`,
        tocItem: true,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#000000',
        margin: [0, 30, 0, 0],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#000000'
          }
        ],
        margin: [0, 5, 0, 20]
      },
      imp,
      {
        text: [
          this.textEd1Deudores,
          `\n`,
          `\n`,
        ],
        alignment: 'justify',
        fontSize: 11,
        color: '#000000',
      },
      tab
    ];
  }
  private async getTablaDeudores(){
    var headers = [];

    const h1 = [
      ...this.encabezadosTabla.flatMap( (e, i) => { return {
        text: e, col: 1, fontSize: 9
      }})
    ];
    headers.push(h1);
    var data = [];
    this.tablaDeudores.forEach( (d, i) =>{
      var aux = [];
      aux.push({
        text: `${i+1}`,
        fontGround: '',
        border: undefined,
        border_color: undefined,
        fontSize: 9,
      });
      aux.push({
        text: `${d.clave}`,
        fontGround: '',
        border: undefined,
        border_color: undefined,
        fontSize: 9,
      });
      aux.push({
        text: `${d.name}`,
        fontGround: '',
        border: undefined,
        border_color: undefined,
        fontSize: 9,
      });
      aux.push({
        text: `${this.formatearnormal(d.value)}`,
        fontGround: '',
        border: undefined,
        border_color: undefined,
        fontSize: 9,
      });
      aux.push({
        text: `${d.porcentaje}`,
        fontGround: '',
        border: undefined,
        border_color: undefined,
        fontSize: 9,
        color: '#0075C9'
      });
      data.push(aux);
    });
    const ta = await generatePDF.table(headers, data);
    return [ta];
  }
  //Conclusiones
  private async conclusionesText(){
    return [
      {
        text: `G. CONCLUSIONES Y RECOMENDACIONES`,
        tocItem: true,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#000000',
        margin: [0, 30, 0, 0],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#000000'
          }
        ],
        margin: [0, 5, 0, 20]
      },
      {
        text: [
          this.textEd1Conclusiones
        ],
        alignment: 'justify',
        fontSize: 11,
        color: '#000000',
      },
    ];
  }
}
